import { useEffect, useState } from "react";

const STORAGE_KEY = "code-forge:theme";

function systemTheme() {
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

function storedTheme() {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === "light" || value === "dark" ? value : null;
  } catch {
    return null;
  }
}

/** Follows the OS theme until the user picks one explicitly. */
export function useTheme() {
  const [explicit, setExplicit] = useState(storedTheme);
  const [system, setSystem] = useState(systemTheme);
  const theme = explicit || system;

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    document.documentElement.style.colorScheme = theme;
  }, [theme]);

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const query = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = (event) => setSystem(event.matches ? "dark" : "light");
    query.addEventListener?.("change", onChange);
    return () => query.removeEventListener?.("change", onChange);
  }, []);

  const toggle = () => {
    const next = theme === "dark" ? "light" : "dark";
    setExplicit(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // Theme choice just will not persist.
    }
  };

  return { theme, toggle };
}
